import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            plugins: string[]
            wt: number
        }
    }
}

export default class GoogleTagManagerSlow extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props
        const plugins = this.props.message?.args.plugins || []

        let info = <div></div>
        let detectedPlugins = <div></div>

        if (message) {
            info = (
                <div>
                    In fact, the plugin currently takes up <Milliseconds value={message.args.wt} /> of the total response generation just
                    for adding Google metadata.
                </div>
            )

            detectedPlugins = (
                <div>
                    <p>Detected Plugins:</p>
                    <ul>
                        {message.args.plugins.map((plugin, index) => (
                            <li key={index}>{plugin}</li>
                        ))}
                    </ul>
                </div>
            )
        }
        return (
            <div>
                <p>
                    You are using a Google Tag Manager plugin on this application that is known to have a massive impact on rendering
                    performance.
                    {info}
                </p>
                {detectedPlugins}
                <p>
                    If this functionality is essential for your store, you should consider a custom implementation, more aggressive caching,
                    or evaluate a different plugin. Many of them are slow though, so be careful here. At the moment, we can&apos;t recommend
                    a fast drop-in replacement.
                </p>
            </div>
        )
    }
}
